var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"font-12 margin-b-3"},[_c('v-tooltip',{attrs:{"top":"","color":"gray"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"cursor-pointer margin-r-2 margin-b-0 margin-l-0",style:({ 'margin-top': '-2px' })},'v-icon',attrs,false),on),[_vm._v(" error ")])]}}])},[_c('span',{staticClass:"tooltip-text font-12 text-white display-block margin-x-0",style:({
        'padding-top': '6px',
        'padding-bottom': '6px',
        'line-height': 1.45,
      })},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])]),_vm._v(" "+_vm._s(_vm.messageText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }